<template>
  <div class="single-value">
    <p
      v-html="items"
      :style="{
        fontSize: configs.parameters['Text size'],
        fontStyle:
          configs.parameters['Text weight'] === 'italic' || configs.parameters['Text weight'] === 'bold-italic'
            ? 'italic'
            : 'normal',
        fontWeight:
          configs.parameters['Text weight'] === 'bold' || configs.parameters['Text weight'] === 'bold-italic'
            ? 'bold'
            : 'normal'
      }"
    ></p>
  </div>
</template>
<script>
export default {
  name: 'DashboardSingleValue',
  props: {
    items: {
      type: String,
      default: ''
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
<style lang="scss">
.single-value {
  width: 100%;
  height: 100%;
  text-align: center;
  display: contents;
}
</style>
